import get from 'lodash/get'
import { required } from '../../utils/validations'

const validate = (values: any) => ({
  verificationCode: required(get(values, 'verificationCode')),
})

export default validate
